var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atom / Play Button / Large Alt / Hover"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    opacity: 0.9,
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#0C1318",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    opacity: 0.8,
    cx: 34,
    cy: 34,
    r: 28.5,
    fill: "url(#paint0_linear_658_21)",
    stroke: "url(#paint1_linear_658_21)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    opacity: 0.8,
    cx: 34,
    cy: 34,
    r: 28.5,
    fill: "url(#paint2_linear_658_21)",
    stroke: "#F7FCFD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M45 32.2679C46.3333 33.0378 46.3333 34.9623 45 35.7321L30 44.3923C28.6667 45.1621 27 44.1999 27 42.6603L27 25.3397C27 23.8001 28.6667 22.8379 30 23.6077L45 32.2679Z",
    fill: "#F8FCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_658_21",
    x1: 64,
    y1: -1.14286,
    x2: -0.923198,
    y2: 58.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_658_21",
    x1: 64,
    y1: -1.14286,
    x2: -0.923198,
    y2: 58.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_658_21",
    x1: 64,
    y1: -1.14286,
    x2: -0.923198,
    y2: 58.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.778d665cdd59be5e8210a29c55e37413.svg";
export { ForwardRef as ReactComponent };